import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { MobileAppIcon } from "@faire/retailer-visitor-shared/icons/MobileAppIcon";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { IconButton } from "@faire/web--source/slate/IconButton";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var MobileFixedBanner = function(param) {
    var message = param.message, ctaText = param.ctaText, ctaLink = param.ctaLink, ctaAction = param.ctaAction, closeAction = param.closeAction, mediumMessageFont = param.mediumMessageFont, icon = param.icon, noIcon = param.noIcon, cornerButton = param.cornerButton;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsxs(StyledRow, {
        align: "flex-start",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                role: "button",
                onClick: function() {
                    ctaAction();
                    if (ctaLink) {
                        var _getWindow;
                        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.open(ctaLink, "_blank");
                    }
                },
                children: [
                    !noIcon ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MobileAppIcon, {
                                size: "48px",
                                icon: icon
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                color: Core.text.inverse,
                                variant: mediumMessageFont ? "paragraphSansMedium" : "paragraphSansRegular",
                                children: message
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(DummyLink, {
                                        color: Core.text.inverse,
                                        children: ctaText
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: "1x"
                                    }),
                                    /*#__PURE__*/ _jsx(Arrow, {
                                        direction: "right",
                                        color: Core.icon.inverse
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            cornerButton ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "5x"
                    }),
                    /*#__PURE__*/ _jsx(AbsoluteIconButton, {
                        onClick: closeAction,
                        "aria-label": strictLocalize({
                            id: "hjWRYd",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Dismiss Banner at the bottom of screen"
                                }
                            ]
                        }),
                        size: "small",
                        children: /*#__PURE__*/ _jsx(Close, {
                            color: Core.icon.inverse
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        onClick: closeAction,
                        "aria-label": strictLocalize({
                            id: "hjWRYd",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Dismiss Banner at the bottom of screen"
                                }
                            ]
                        }),
                        size: "small",
                        children: /*#__PURE__*/ _jsx(Close, {
                            color: Core.icon.inverse
                        })
                    })
                ]
            })
        ]
    });
};
var StyledRow = styled(Row).withConfig({
    componentId: "sc-4cd650de-0"
})([
    "width:100%;background:",
    ";padding:16px;"
], Core.surface.default);
var DummyLink = styled(Typography).withConfig({
    componentId: "sc-4cd650de-1"
})([
    "text-decoration:underline;"
]);
var AbsoluteIconButton = styled(IconButton).withConfig({
    componentId: "sc-4cd650de-2"
})([
    "position:absolute;top:",
    ";right:",
    ";"
], getSpacing("1x"), getSpacing("1x"));
